var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.getIsMobile)?_c('div',{staticClass:"text"},[_c('p',[_vm._v("You are already logged in as Company user")]),_c('p',[_vm._v("Do you want to logout and login as Application user ?")]),_c('el-button',{staticClass:"mt-1",attrs:{"type":"primary"},on:{"click":_vm.logoutUser}},[_vm._v("Logout")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }